/* angular */
import { createAction, props } from '@ngrx/store';

/* payloads */
import { UpdateSelectedTabIndexForEditTourPageActionPayload } from 'src/app/features/shared/models/event/app-data-store';

/* action types */
export enum ActionTypes {
  UpdateSelectedTabIndexForEditTourPage = '[APP] UpdateSelectedTabIndexForEditTourPage',
  InitApp = '[APP] InitApp',
}

/* actions */

export const UpdateSelectedTabIndexForEditTourPage = createAction(
  ActionTypes.UpdateSelectedTabIndexForEditTourPage,
  props<{ payload: UpdateSelectedTabIndexForEditTourPageActionPayload }>(),
);

/* This event is fired when the app is started */
export const InitApp = createAction(ActionTypes.InitApp);
